import { Component, input } from "@angular/core";
import { NbIconModule } from "@nebular/theme";

@Component({
  standalone: true,
  selector: "ngx-heading",
  template: `
    <div class="d-flex align-items-top mb-4">
      <nb-icon
        [icon]="icon()"
        [status]="status()"
        pack="mirasee"
        class="flex-shrink-0 fs-3"
      ></nb-icon>
      <div class="flex-grow-1 ms-3 align-self-center">
        <h2 [class.mb-0]="!caption()"><ng-content></ng-content></h2>
        @if (caption()) {
        <p class="text-disabled mt-2 mb-0">{{ caption() }}</p>
        }
      </div>
    </div>
  `,
  imports: [NbIconModule],
})
export class HeadingComponent {
  caption = input<string>();
  icon = input<string>();
  status = input<string>("info");
}
